// extracted by mini-css-extract-plugin
export default {"btn":"ShareButton_btn__SDaF+","icon":"ShareButton_icon__eOXHx"};